import { css } from '@emotion/css'
import { getIrrigationStatusColors } from 'App/Map/_utils/getIrrigationStatusColors'
import type { TIrrigationDeviceStatus } from 'App/Map/types'
import { translate } from 'i18n/i18n'

export const getTooltipSectionForIntervalsChart = ({
  appliedWater,
  isScheduled,
  periodDurationText,
  periodFromDateText,
  periodToDateText,
  status,
}: {
  appliedWater: string | null
  isScheduled: boolean
  periodDurationText: string
  periodFromDateText: string
  periodToDateText: string
  status: TIrrigationDeviceStatus
}) => {
  const { color, backgroundColor } = getIrrigationStatusColors(status)

  const styleString = css`
    border: 2px solid white;
    background: ${backgroundColor};
    border-radius: 95px;
    padding: 4px 10px;
    font-size: 12px;
    color: ${color};
  `

  return `
<table>
<tr style="display: flex; align-items: center; justify-content: space-between; padding: 5px 0;">
  <td class="${styleString}">${status ? status.toUpperCase() : ''}</td>
  <td><b>${periodDurationText}</b></td>
</tr>
<tr style="padding: 5px 0;">
  <td><b>${periodFromDateText} -</b></td>
</tr>
<tr style="padding: 5px 0;">
  <td><b>${periodToDateText}</b></td>
</tr>
${
  appliedWater
    ? `<tr style="display: flex; align-items: center; justify-content: space-between; padding: 5px 0;">
  <td>${isScheduled ? translate.phrases.banyanApp('Scheduled') : translate.phrases.banyanApp('Applied')}</td>
  <td><b>${appliedWater}</b></td>
</tr>`
    : ''
}
</table>
`
}
